import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import FadeConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/fade';
import MorphConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/morph';
import PushConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/push';
import SwitchConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/switch';
import CutConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/cut';
import PullConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/pull';
import CoverConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/cover';
import WarpConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/warp';
import NewsflashConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/newsflash';
import FlipConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/flip';
import GalleryConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/gallery';
import PrismConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/prism';
import FlashConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/flash';
import BaseTransitionConverter, { DefaultTransitionConverter } from '@src/slide/domain/ui-model/element-modeles/transition/converter/base';

// eslint-disable-next-line complexity
export function getTransitionConverterByType(type?: TransitionType): BaseTransitionConverter {
    switch (type) {
        case TransitionType.FADE:
            return new FadeConverter();
        // morph之前显示降级为fade，但是支持编辑之后存在交互问题。移除降级当不支持处理
        // case TransitionType.MORPH:
        //     return new MorphConverter();
        case TransitionType.PUSH:
            return new PushConverter();
        case TransitionType.SWITCH:
            return new SwitchConverter();
        case TransitionType.CUT:
            return new CutConverter();
        case TransitionType.PULL:
            return new PullConverter();
        case TransitionType.COVER:
            return new CoverConverter();
        case TransitionType.WARP:
            return new WarpConverter();
        case TransitionType.NEWSFLASH:
            return new NewsflashConverter();
        case TransitionType.FLIP:
            return new FlipConverter();
        case TransitionType.GALLERY:
            return new GalleryConverter();
        case TransitionType.PRISM:
            return new PrismConverter();
        case TransitionType.FLASH:
            return new FlashConverter();
        default:
            return new DefaultTransitionConverter();
    }
}
